import type {DalValue, RefInfo} from '@wix/document-services-types'
import type {DetailedValue} from './types'

interface PathNode {
    parentNode?: PathNode
    path: string
}

const pathNodeToArray = (pathNode: PathNode | undefined): string[] => {
    const pathArr = []
    while (pathNode) {
        pathArr.unshift(pathNode.path)
        pathNode = pathNode.parentNode
    }

    return pathArr
}

const gatherItems = (
    valuesListAccumulator: DetailedValue[],
    item: DalValue,
    path: string[],
    pathNode?: PathNode,
    pathIndex: number = 0
) => {
    for (let i = pathIndex; i < path.length && item; i++) {
        const currentPath = path[i]
        item = item[currentPath]
        pathNode = {
            path: currentPath,
            parentNode: pathNode
        }

        if (Array.isArray(item)) {
            for (let j = 0; j < item.length; j++) {
                const value = item[j]
                const parentPathNode: PathNode = {
                    path: `${j}`,
                    parentNode: pathNode
                }
                gatherItems(valuesListAccumulator, value, path, parentPathNode, i + 1)
            }
            return
        }
    }

    if (item !== undefined) {
        valuesListAccumulator.push({value: item, path: pathNodeToArray(pathNode)})
    }
}

export const getDetailedValueByPath = (ownerItem: DalValue, path: string[] | RefInfo['path']): DetailedValue[] => {
    const items: DetailedValue[] = []
    gatherItems(items, ownerItem, path as string[])
    return items
}
